import React, { useEffect, useState } from "react";
import "./CSS/Global.css";
import Header from "./Header";
import { Link } from "react-router-dom";
import Footer from "./Footer";



const categories = ["All", "Photography", "Travel", "Nature", "Fashion", "Life Style"];

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [data, setData] = useState([])
  // const filteredImages =
  //   selectedCategory === "All"
  //     ? images
  //     : images.filter((image) => image.category === selectedCategory);


  const fetchData = async () => {
    try {
      const response = await fetch("https://100billionrealestate.com/gallery");
      const res = await response.json();
      setData(res.gallery);
    } catch (error) {
      console.log(error);
    }
  };

  console.log(data);
  useEffect(() => {
    fetchData();
  }, [])

  return (
    <>
      <Header />
      <div className="gallery-container">
        {/* Header */}
        <h1>Welcome to 100billion Tech</h1>
        <p>With Best  Website Development</p>

        {/* Filter Menu */}
        {/* <div className="filter-menu">
        {categories.map((category) => (
          <button
            key={category}
            className={selectedCategory === category ? "active" : ""}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div> */}

        {/* Masonry Grid */}
        <div className="maindivgallery">
          <div className="offices-container">
            {data.map((office) => (
              <div key={office.id} className="office-card">
                <div className="office-image">
                  <img src={`https://100billionrealestate.com/${office.main_image}`} alt={office.name} />

                </div>
                <div className="office-info">
                  <h3>{office.title}</h3>
                  <p className="officeinfoptag">
                    {office.description}
                  </p>
                  <Link to={`/event-gallery/${office.id}`} className="directions-btn">
                    <i className="fas fa-external-link-alt"></i> View Gallery
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Gallery;
